import axios, { AxiosRequestConfig } from "axios";
import { getI18n } from "react-i18next";
import { getJwt, removeJwt } from "utils/jwt";

const addAuthorizationHeader = (config: AxiosRequestConfig) => {
  const jwtToken = getJwt();
  if (jwtToken) config.headers!["Authorization"] = `Bearer ${jwtToken}`;
  return config;
};

const addCustomHeader = (config: AxiosRequestConfig) => {
  config.headers!["Accept"] = 'application/json';
  config.headers!["Accept-Language"] = getI18n().languages.join(',');
  return config;
};

const redirectToLoginOnTokenExpiration = (error: any) => {
  if (error.response.status === 401 && getJwt() !== null) {
    removeJwt();
    window.location.href = "/?session_expired";
  }
  return Promise.reject(error);
};

const configureAxios = () => {
  axios.interceptors.request.use(addAuthorizationHeader);
  axios.interceptors.request.use(addCustomHeader);
  axios.interceptors.response.use((response) => response, redirectToLoginOnTokenExpiration);
};

export default configureAxios;
